const variables = {
	appUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""),
	apiEndpoint: process.env.VUE_APP_API_URL,
};

export default variables;
